import type { Locale } from '@lemonade-hq/lemonation';
import type { Config as PetConfig } from './us/en';
import { config as enUsConfig } from './us/en';

export type Config = PetConfig;

export const petTemplateConfig = {
  'en-US': enUsConfig,
  'en-GB': enUsConfig,
  'en-FR': enUsConfig,
  'en-DE': enUsConfig,
  'en-NL': enUsConfig,
  'nl-NL': enUsConfig,
  'de-DE': enUsConfig,
  'fr-FR': enUsConfig,
} as Record<Locale, Config>;
